import { Tag } from 'react-tag-autocomplete';
import SurfaceExaminedHistory from './tract_detail/SurfaceExaminedHistory';
import Ownership from './tract_detail/Ownership';
import TractDetail from './tract_detail/TractDetail';
import Owner from './tract_detail/Owner';
import Abstract from './Abstract';

export default class {
    id: number;
    name: string;
    acres: number;
    isPartial: boolean;
    partialAcreage: number;
    grantor: string;
    grantee: string;
    recordTypeId: number;
    book: string;
    page: string;
    recordDate: Date;
    boundByNorth: string;
    boundBySouth: string;
    boundByWest: string;
    boundByEast: string;
    legalDescription: string;
    number: number;
    instrumentTypeId: number;
    countyId: number;
    note: string;
    ownerships: Array<Ownership>;
    tags: Array<Tag>;
    addTags?: Array<Tag>;
    deleteTags?: Array<Tag>;
    abstracts: Array<Abstract>;
    examinedHistories: Array<SurfaceExaminedHistory>;
    mineralTracts: Array<TractDetail>;
    owners: Array<Owner>;
}



// WEBPACK FOOTER //
// ./src/models/SurfaceTract.ts